import { SDK } from "@sdk";

import { iDynamicForm } from "@sdk/dynamic-forms/dynamic-forms-model";
import { Store } from "redux";
import { QueryConfig } from "store/utils/query-config";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { dynamicFormsDefaultQueryConfig } from "./dynamic-forms-default-query";
import { DynamicFormsSlice } from "./dynamic-forms.slice";

export const loadAllDynamicForms = () => async (
  store: Store<iStore>,
  forceReload?: boolean
) => {
  await loadDynamicFormsQuery(dynamicFormsDefaultQueryConfig, "all")(
    store,
    forceReload
  );
};

export const loadQueryDynamicForms = (
  queryConfig: QueryConfig,
  queryAlias?: string
) => async (store: Store<iStore>, forceReload?: boolean) => {
  queryAlias = queryAlias || JSON.stringify(queryConfig);
  await loadDynamicFormsQuery(queryConfig, queryAlias)(store, forceReload);
};

export const {
  loadEntityQueries: loadDynamicFormsQuery,
  loadEntityById: loadDynamicFormById,
  loadMoreEntityQueries: loadMoreDynamicFormsQueries
} = CreateHelpersForEntity<iStore, iDynamicForm>({
  sliceName: "dynamicForms",
  slice: DynamicFormsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 50,
  loadEntityQueryProvider: query => SDK.dynamicForms.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.dynamicForms.getById(entityId)
});
